import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { NzDrawerPlacement } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';

@Component({
  selector: 'atw-count-down-config-desktop',
  templateUrl: './config-desktop.component.html',
  styleUrls: ['./config-desktop.component.scss']
})
export class CountDownConfigDesktopComponent implements OnInit {

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private message: NzMessageService,
    private datePipe: DatePipe,
    @Inject(PLATFORM_ID) private platformId: Object,) {

  }

  @Input() visible_config_tool = false;
  @Input() data_tool: any = {};
  @Output() closeConfigEvent = new EventEmitter<any>();
  @Output() update = new EventEmitter();
  @Output() time = new EventEmitter();
  @Output() display = new EventEmitter();
  @Input() device: any
  dataAfterChange: any = {}
  CheckMethod: any;// biến để setTimeout
  BgColorDefault: any;///màu ban đầu của nền
  BorderColorDefault: any;//màu ban đầu border
  ObjectStyle: any;
  checkTimeIsCorrect = true;//check xem lấy ngày bắt đầu và ngày kết thúc đúng không
  date_end = new Date();//để lấy ngày kết thúc
  date = new Date();//lấy ngày bắt đầu
  dateStart: any;//biến để set ngày vào ô input
  dateEnd: any;//biến để set ngày vào ô input

  fonts = [
    { "name": "Lato", "value": "'Lato', sans-serif" },
    { "name": "Arial", "value": "Arial" },
    { "name": "Comic Sans MS", "value": "'Comic Sans MS',Arial" },
    { "name": "Lobster", "value": "'Lobster', cursive" },
    { "name": "Caveat", "value": "'Caveat', cursive" },
    { "name": "Roboto", "value": "'Roboto', sans-serif" },
    { "name": "Poppins", "value": "'Poppins', sans-serif" },
    { "name": "Pacifico", "value": "'Pacifico', cursive" },
    { "name": "Times New Roman", "value": "'Times New Roman',Arial" },
    { "name": "Lora", "value": "Lora" },
    { "name": "Lavishly Yours", "value": "'Lavishly Yours', cursive" },
    { "name": "Georgia", "value": "Georgia" },
    { "name": "Serif", "value": "serif" },
    { "name": "Cursive", "value": "cursive" },
    { "name": "Noto Serif", "value": "serif" }
  ]
  option_style = [
    { name: 'Kiểu 1', img: '../../../../../../assets/root/img/user/countdownStyle/kieu1.jpg', option: 1 },
    { name: 'Kiểu 2', img: '../../../../../../assets/root/img/user/countdownStyle/kieu2.jpg', option: 2 },
    { name: 'Kiểu 3', img: '../../../../../../assets/root/img/user/countdownStyle/kieu3.jpg', option: 3 },
    { name: 'Kiểu 4', img: '../../../../../../assets/root/img/user/countdownStyle/kieu4.jpg', option: 4 },
    { name: 'Kiểu 5', img: '../../../../../../assets/root/img/user/countdownStyle/kieu5.jpg', option: 5 },
    { name: 'Kiểu 6', img: '../../../../../../assets/root/img/user/countdownStyle/kieu6.jpg', option: 6 },
    { name: 'Kiểu 7', img: '../../../../../../assets/root/img/user/countdownStyle/kieu7.jpg', option: 7 },
    { name: 'Kiểu 8', img: '../../../../../../assets/root/img/user/countdownStyle/kieu8.jpg', option: 8 },
    { name: 'Kiểu 9', img: '../../../../../../assets/root/img/user/countdownStyle/kieu9.jpg', option: 9 },

  ]
  backgroundColor: any = [
    {
      bgColor: '#000000',
      name: 'Đen',
      hex: '#000000',
    },
    {
      bgColor: '#808080',
      name: 'Xám',
      hex: '#808080',
    },
    {
      bgColor: '#A9A9A9',
      name: 'Xám đen',
      hex: '#A9A9A9',
    },
    {
      bgColor: '#BEBEBE',
      name: 'Xám nhạt',
      hex: '#A9A9A9',
    },
    {
      bgColor: '#C0C0C0',
      name: 'Bạc',
      hex: '#C0C0C0',
    },
    {
      bgColor: '#FFFFFF',
      name: 'Trắng',
      hex: '#FFFFFF',
    },
    {
      bgColor: '#ff1616',
      name: 'Đỏ',
      hex: '#ff1616',
    },
    {
      bgColor: '#F08080',
      name: 'Đỏ san hô',
      hex: '#F08080',
    },
    {
      bgColor: '#EE82EE',
      name: 'Màu tím',
      hex: '#EE82EE',
    },
    {
      bgColor: '#800080',
      name: 'Màu tím',
      hex: '#800080',
    },
    {
      bgColor: '#8c52ff',
      name: 'Màu tía',
      hex: '#8c52ff',
    },
    {
      bgColor: '#FFC0CB',
      name: 'Hồng',
      hex: '#FFC0CB',
    },
    {
      bgColor: '#FF1493',
      name: 'Màu hồng đậm',
      hex: '#FF1493',
    },
    {
      bgColor: '#FFB6C1',
      name: 'Màu hồng nhạt',
      hex: '#FFB6C1',
    },
    {
      bgColor: '#00FFFF',
      name: 'Màu lục lam',
      hex: '#00FFFF',
    },
    {
      bgColor: '#40E0D0',
      name: 'Màu ngọc lam',
      hex: '#40E0D0',
    },
    {
      bgColor: '#00c2cb',
      name: 'Xanh nước biển',
      hex: '#00c2cb',
    },
    {
      bgColor: '#4169E1',
      name: 'Xanh đậm',
      hex: '#4169E1',
    },
    {
      bgColor: '#0000FF',
      name: 'Xanh da trời',
      hex: '#0000FF',
    },
    {
      bgColor: '#008037',
      name: 'Lục',
      hex: '#008037',
    },
    {
      bgColor: '#7ed957',
      name: 'Xanh lá',
      hex: '#7ed957',
    },
    {
      bgColor: '#c9e265',
      name: 'Vàng chanh',
      hex: '#c9e265',
    },
    {
      bgColor: '#ffde59',
      name: 'Vàng',
      hex: '#ffde59',
    },
    {
      bgColor: '#ffbd59',
      name: 'Hồng đào',
      hex: '#ffbd59',
    },
    {
      bgColor: '#ff914d',
      name: 'Cam',
      hex: '#ff914d',
    },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.option_style) {


    }
  }
  ngOnInit(): void {
    if (this.data_tool.data.date_start)
      this.setFormatDay();
  }
  updateDisplay() {
    this.display.emit(this.data_tool.data.display_now);
    this.updateCss('data', this.data_tool.data)
  }
  //cập nhật option khi thay đổi
  updateOption() {
    this.update.emit(this.data_tool.data.option);

    this.saveDataProperties();
    this.updateFormat;
  }
  updateTime() {
    this.time.emit(this.data_tool.data.date_start);
    this.saveDataProperties();
  }
  chooseBgIn(bgColor, optionName, e) {
    if (isPlatformBrowser(this.platformId)) {
      // sự kiện hightlight active cho mỗi phần tử được click vào
      var activeGradient = document.querySelector(
        '.contains .active'
      ) as HTMLElement;
      if (activeGradient) {
        if (activeGradient == e.currentTarget)
          this.data_tool[optionName].background_in = this.BgColorDefault;

        else {
          e.currentTarget.classList.add('active');
          this.data_tool[optionName].background_in = bgColor.bgColor;
        }
        activeGradient.classList.remove('active');
      }
      else {
        e.currentTarget.classList.add('active');
        this.data_tool[optionName].background_in = bgColor.bgColor;
      }
      this.updateCss(optionName, this.data_tool[optionName]);
    }
  }

  chooseBgOut(bgColor, optionName, e) {
    if (isPlatformBrowser(this.platformId)) {
      var activeGradient = document.querySelector('.contains .active') as HTMLElement;
      if (activeGradient) {
        if (activeGradient == e.currentTarget)
          this.data_tool[optionName].background_out = this.BorderColorDefault;

        else {
          e.currentTarget.classList.add('active');
          this.data_tool[optionName].background_out = bgColor.bgColor;
        }
        activeGradient.classList.remove('active');
      }
      else {
        e.currentTarget.classList.add('active');
        this.data_tool[optionName].background_out = bgColor.bgColor;
      }
      this.updateCss(optionName, this.data_tool[optionName]);
    }

  }
  SelectedOption(option: any, event: any) {
    if (isPlatformBrowser(this.platformId)) {
      var lastSelectElm = document.querySelector('.box-item.selected') as HTMLElement;
      if (this.data_tool.data.option == option) {
        this.data_tool.data.option = 0;
        lastSelectElm.classList.remove('selected')
      }
      else {
        this.data_tool.data.option = option;
        if (option <= 6) {
          this.ObjectStyle = "desktop_format_option_" + option;
          this.BgColorDefault = this.data_tool[this.ObjectStyle].background_in;
          this.BorderColorDefault = this.data_tool[this.ObjectStyle].background_out;
        }
      }
      this.updateOption();
      this.updateCss('data', this.data_tool.data);
    }
  }
  //chọn màu chữ
  openColor(element: string) {
    if (isPlatformBrowser(this.platformId)) document.getElementById(element).click()
  }
  //đóng
  close() {
    this.closeConfigEvent.emit(false);
    this.saveDataProperties();
  }

  setFormatDay() {
    this.dateStart = new Date(this.data_tool.data.date_start);
    this.dateEnd = new Date(this.data_tool.data.date_end);
    const dateSetting = this.datePipe.transform(this.dateStart, 'yyyy-MM-ddTHH:mm');
    this.dateStart = dateSetting.substring(0, 16);
    const dateSetting1 = this.datePipe.transform(this.dateEnd, 'yyyy-MM-ddTHH:mm');
    this.dateEnd = dateSetting1.substring(0, 16);
  }

  updateDynamic(name, value) {
    this.dataAfterChange[name] = value;
  }
  updateFormat(name: string, value: boolean) {
    if (name === 'format_countdown_daytime') {
      if (value) {
        this.data_tool.format_countdown_default = false;
        this.dataAfterChange["format_countdown_default"] = false;

      }
    } else if (name === 'format_countdown_default') {
      if (value) {
        this.data_tool.format_countdown_daytime = false;
        this.dataAfterChange["format_countdown_daytime"] = false;

      }
    }
    this.dataAfterChange[name] = value;


  }
  //Cập nhật css sau của object sau khi thay đôi
  updateCss(name: any, key: any) {
    this.dataAfterChange[name] = { ...key }

    this.saveDataProperties();
  }
  //lưu vào DB
  saveDataProperties() {
    if (this.dataAfterChange) {
      this.vhQueryAutoWeb.updateObject(this.data_tool._id, this.dataAfterChange)
        .then((bool) => {


        }, error => {
          console.error(error)
        })
    }
  }
  //kiểm tra ngày bắt đầu cài đặt
  CheckDayInput(date: any) {
    if (date) {
      this.date = new Date(date);
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      if (this.date < currentDate) {
        this.checkTimeIsCorrect = true;
        this.createMessage('Ngày cài đặt bắt đầu không hợp lệ');
      }
      else {
        if (this.data_tool.data.date_end) {
          this.checkTimeIsCorrect = false;
          this.dateEnd = this.datePipe.transform(this.date_end, 'yyyy-MM-ddTHH:mm');
        }
        this.dateStart = this.datePipe.transform(this.date, 'yyyy-MM-ddTHH:mm');
      }
    }
  }
  //kiểm tra ngày kết thúc
  CheckDayEnd(date: any) {
    if (date) {
      const currentDate = new Date();
      this.date_end = new Date(date);
      if (this.date > this.date_end && this.date_end > currentDate) {
        this.createMessage('Ngày cài đặt kết thúc không hợp lệ');
        this.checkTimeIsCorrect = true;
      }
      else {
        this.checkTimeIsCorrect = false;
        this.data_tool.data.date_end = this.date_end;
        this.dateEnd = this.datePipe.transform(this.date_end, 'yyyy-MM-ddTHH:mm');
      }
    }
  }
  createMessage(info: any): void {
    this.message.error(info);
  }
  //cập nhật thời gian
  SetTime() {
    this.checkTimeIsCorrect = !this.checkTimeIsCorrect;
    this.data_tool.data.date_start = this.date;
    this.updateCss('data', this.data_tool.data)
    this.updateTime();
  }
  //lấy màu nền
  openBgColor(element: string) {
    if (isPlatformBrowser(this.platformId))  document.getElementById(element).click();
  }

  // update trường mobile_portrait_hidden or desktop_hidden cho object
  updateHidden(value) {

    this.vhQueryAutoWeb.updateObject(this.data_tool._id, value)
      .then((bool) => {

      }, error => {
        console.error(error)
      })
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
}
